import { styled } from '@mui/material';

import { CircularProgressPaper } from '~/components/CircularProgressPaper/CircularProgressPaper';

export const WidgetContentInner = styled('div')({
  display: 'flex',
  height: '100%',
  padding: 0,
  position: 'relative',
});

export const CircularProgressPaperStyled = styled(CircularProgressPaper)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(3),
  left: '50%',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
}));
